var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/01194ec1f2f7a8ba5cf9bd34a6d7b12c.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3c6f81f2c985f2bdb4916013dcf6ad4d.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea1ab1c923b5b281af2c28ed275ec8d4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    